import BaseAction from "../base-action";
import {ActionTypeEnum} from "../../base/training-literals";

class ResetModel extends BaseAction {
    models;

    constructor(props = {}) {
        super(props);
        this.actionType = ActionTypeEnum.RESET_MODEL;
        this.models = props.models || [];
    }

    get(props = {}) {
        return {
            type: this.actionType,
            models: props.models || this.models,
            duration: props.duration || this.duration,
        }
    }
}

export default ResetModel;